import { Toast } from 'vant';
import { getCookie } from '@/common/utils/tools';
import { dateFns, throttle } from '@lhb/func';
function resetRootFontSize() {
    var screenWidth = window.screen.width;
    var docFontSize = screenWidth / 10;
    // Toast({
    //   duration: 0,
    //   message: `此时的屏幕宽度: ${screenWidth}, HTML根字体大小：${docFontSize}`
    // });
    docFontSize && (document.documentElement.style.fontSize = docFontSize + "px");
}
// 使用惰性函数: 因为el只需要执行一次删除操作即可
var routerAfterEach = function (to, from) {
    resetRootFontSize(); // 默认执行一次
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    routerAfterEach = function (to, from) {
        // 需要的其他处理
        if (process.env.NODE_ENV !== 'development') { // 开发环境屏蔽
            // 先发送离开页面的信息 再上传进入页面的信息
            window.LHBbigdata.spa.beforeRouteLeave()(to, from);
            window.LHBbigdata.spa.beforeRouteEnter()(to, from);
        }
        // 强制刷新根元素的font-size(三方应用内，偶发性的rem失效)
        window.addEventListener('resize', throttle(function () {
            resetRootFontSize();
        }, 150));
    };
    // 需要额外处理时执行
    routerAfterEach(to, from);
};
var routerBeforeEach = function (to, from, next) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    routerBeforeEach = function (to, from, next) {
        if (to.meta.title) {
            window.document.title = "" + to.meta.title;
        }
        else {
            process.env.NODE_ENV === 'development' && window.location.pathname !== '/' &&
                Toast('为了方便数据采集，请添加title！');
        }
        var meta = (to || {}).meta;
        if (meta && meta.url && meta.urlName) {
            var url = meta.url, urlName = meta.urlName;
            var employeeId = getCookie('EMPLOYEE_ID');
            var tenantId = getCookie('TENANT_ID');
            var msg = {
                report_time: dateFns.currentTime('', false),
                url: url,
                urlName: urlName
            };
            if (employeeId)
                msg.user_id = employeeId;
            if (tenantId)
                msg.tenant_id = tenantId;
            window.LHBbigdata.send({
                msg: msg
            });
        }
        // 需要的其他处理
        next();
    };
    // 需要额外处理时执行
    routerBeforeEach(to, from, next);
};
export default function routerControl(router) {
    router.afterEach(function (to, from) {
        routerAfterEach(to, from);
    });
    router.beforeEach(function (to, from, next) {
        routerBeforeEach(to, from, next);
    });
}
